import { getToken } from 'firebase/messaging';
import { subscribeFCMToken } from 'wisestep-api';

import { messaging } from './firebase';

// VAPID key should be consistent across the application
export const FIREBASE_VAPID_KEY =
  'BI70is4UUAuEoCWL3ahtTDAs__c4dbKYA_xUICSJB5LLfUTkSz24h6HlhgL91gI3-I4xjKQg4gjMfn0ibDCVlS4';

/**
 * Gets FCM token and sends it to the backend
 * @returns The FCM token if successful, null otherwise
 */
export const getFCMTokenAndSubscribe = async (): Promise<string | null> => {
  try {
    // Wait for service worker registration
    const registration = await navigator.serviceWorker.ready;
    console.log('[FCM] Service worker ready:', registration.scope);

    // Get token
    const token = await getToken(messaging, {
      vapidKey: FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    console.log(token);

    if (token) {
      console.log('[FCM] Token obtained:', token);
      // Send token to backend
      await subscribeFCMToken(token);
      localStorage.removeItem('FCMToken');
      localStorage.setItem('FCMToken', token);
      return token;
    } else {
      console.warn('[FCM] No token available');
      return null;
    }
  } catch (error) {
    console.error('[FCM] Error getting token:', error);
    return null;
  }
};
